import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(37, 63, 115, 0.4);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
`;

export const ModalContainer = styled.div`
  width: 100%;
  max-width: 600px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 8px 24px rgba(23, 42, 63, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid #e9e9e9;
`;

export const ModalTitle = styled.h2`
  font-family: "Readex Pro", sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #172a3f;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 32px;
  color: #606060;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;

  &:hover {
    color: #172a3f;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ModalBody = styled.div`
  padding: 24px 32px;
  overflow-y: auto;
  flex: 1;
`;

export const FormGroup = styled.div`
  margin-bottom: 24px;
`;

export const Label = styled.label`
  display: block;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #172a3f;
  margin-bottom: 8px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus {
    border-color: #55b8b3;
  }

  &:disabled {
    background: #f4f4f4;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #bbbbbb;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px 16px;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  background: #ffffff;
  cursor: pointer;

  &:focus {
    border-color: #55b8b3;
  }

  &:disabled {
    background: #f4f4f4;
    cursor: not-allowed;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px 16px;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    border-color: #55b8b3;
  }

  &:disabled {
    background: #f4f4f4;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #bbbbbb;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px 32px;
  border-top: 1px solid #e9e9e9;
`;

export const CancelButton = styled.button`
  padding: 12px 24px;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #606060;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f4f4f4;
    border-color: #d0d0d0;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const SubmitButton = styled.button`
  padding: 12px 24px;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background: #55b8b3;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #4aa9a4;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const ErrorMessage = styled.div`
  padding: 12px 16px;
  background: #fadbd8;
  border: 1px solid #e74c3c;
  border-radius: 4px;
  color: #c0392b;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  margin-bottom: 16px;
`;
